export const STATUSES = {
    LIVE: 'active',
    EDIT: 'edit',
    UPGRADE: 'upgrade',
    LIMIT_REACHED: 'limit',
};

export const STATUSES_COLOR_MAP = {
    [STATUSES.LIVE]: 'var(--green300)',
    [STATUSES.EDIT]: 'var(--orange300)',
    [STATUSES.UPGRADE]: 'var(--orange300)',
    [STATUSES.LIMIT_REACHED]: 'var(--orange300)',
};

export const DOMAIN_TYPES = {
    BRANDED: 'Branded',
    SINGULAR: 'Singular',
};

export const TABLE_KEYS = {
    DOMAIN: 'domain',
    DOMAIN_TYPE: 'domain_type',
    STATUS: 'status',
    ACTIONS: 'actions',
};

export const TRANSLATION_PREFIX = 'STATIC.PAGES.MANAGE_LINKS.SUB_DOMAIN.TABLE';
export const DOMAIN_LIMIT_WARNING_KEY = 'STATIC.PAGES.MANAGE_LINKS.SUBDOMAIN_SHELF_LIMIT_REACHED_WARNING';

export const COLUMN_NAMES = {
    DOMAIN_TYPE: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.DOMAIN_TYPE`,
    DOMAIN: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.DOMAIN`,
    STATUS: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.STATUS`,
    ACTIONS: `${TRANSLATION_PREFIX}.COLUMNS_DISPLAY.ACTIONS`,
};

export const STATUS_TEXT_KEYS = {
    LIVE: `${TRANSLATION_PREFIX}.STATUS.LIVE`,
    UPGRADE: `${TRANSLATION_PREFIX}.STATUS.UPGRADE_REQUIRED`,
    EDIT: `${TRANSLATION_PREFIX}.STATUS.EDIT`,
    LIMIT_REACHED: `${TRANSLATION_PREFIX}.STATUS.LIMIT_REACHED`,
};

export const STATUS_SUB_VALUES = {
    [STATUSES.EDIT]: `${TRANSLATION_PREFIX}.SUB_STATUS.EDIT`,
    [STATUSES.LIVE]: `${TRANSLATION_PREFIX}.SUB_STATUS.LIVE`,
    [STATUSES.LIMIT_REACHED]: '',
    [STATUSES.UPGRADE]: `${TRANSLATION_PREFIX}.SUB_STATUS.UPGRADE`,
};

export const VALIDATION_MESSAGES = {
    REQUIRED: `${TRANSLATION_PREFIX}.SUBDOMAIN_ERRORS.REQUIRED`,
    INVALID_FORMAT: `${TRANSLATION_PREFIX}.SUBDOMAIN_ERRORS.INVALID_FORMAT`,
    DUPLICATE: `${TRANSLATION_PREFIX}.SUBDOMAIN_ERRORS.DUPLICATE`,
};

export const TTypeEnum = {
    ALERT: 'alert',
};
